// import $ from "jquery";

// import script accordingly
// import "./themes/header/_header";
// import "./themes/header/_footer";
import "./themes/components/_component";
